import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import React from 'react'
import style from '../styles/tourn_detail.module.scss'

const FiltersLoader = (): React.ReactElement => {
  return (
    <div className={style.filters}>
      <ul className={style.filters_buttons}>
        <li className={style.members__item}>
          <PlaceholderLoading shape='rect' width='100%' height='100px' />
        </li>
        <li className={style.members__item}>
          <PlaceholderLoading shape='rect' width='100%' height='100px' />
        </li>
        <li className={style.members__item}>
          <PlaceholderLoading shape='rect' width='100%' height='100px' />
        </li>
        <li className={style.members__item}>
          <PlaceholderLoading shape='rect' width='100%' height='100px' />
        </li>
      </ul>
    </div>
  )
}

export {
  FiltersLoader
}
